import React from "react";
import styled from "styled-components";
import { Box, Typography } from "@mui/material";
import { colors } from "../../utils";
import TextView from "../TextView";
import CustomSlider from "../SegmentBuilder/Shared/Slider";
import ColorPopup from "../SegmentBuilder/Shared/ColorPopup";

const Container = styled.div`
  width: 100%;
  background-color: ${colors.background};
  border-radius: 8px;
  padding: 16px;
  border: 1px solid ${colors.lightBorder};
  margin-top: 12px;
`;

function WallpaperImageSettings({
  huePercentage = 0,
  huePercentageChange,
  hueColor = "#ffffff",
  hueColorChange,
}) {
  return (
    <Container>
      <Box mt={2}>
        <CustomSlider
          title="Hue Percentage"
          value={huePercentage}
          onChange={huePercentageChange}
          min={0}
          max={100}
        />
      </Box>
      <Box mt={2}>
        <Typography sx={{ fontWeight: "400", fontSize: "14px", fontFamily: "DM Sans", mb: 1 }}>
          Hue Color
        </Typography>
        <ColorPopup
          title="Hue Color"
          background={hueColor}
          handleChangeBackgroundColor={hueColorChange}
          resetBackgroundColor={() => hueColorChange("#ffffff")}
          showSlider={false}
          showAccordion={false}
          isHideGradient={true}
        />
      </Box>
    </Container>
  );
}

export default WallpaperImageSettings;
